/**
 * All available routes for the app
 */

export const HOME = '/';

export const FORGOT_PASSWORD = '/forgot-password';

export const RESET_PASSWORD = '/reset-password';

export const USER_PROFILE = '/:username';

export const EDIT_INFO = '/edit-info';

export const EXPLORE = '/explore';

export const LEARNER = '/learners';

export const NOTIFICATIONS = '/notifications';

export const LANGFORUM = '/langforum';

export const MESSAGES = '/messages/:userId';

export const POST = '/post/:id';

export const FOLLOWERS = '/:username/followers';

export const FOLLOWING = '/:username/following';

/**
 * Value that's used in place of id when creating something new.
 */
export const NEW_ID_VALUE = 'new';
